import React from "react";
import { AlertCircle } from "lucide-react";

// Dollar → credit conversions mirror the top-up packs (25 credits / $1).
const QUICK_PICKS = [
  { dollars: 10, credits: 250 },
  { dollars: 25, credits: 625 },
  { dollars: 50, credits: 1250 },
];

/**
 * Dedicated "you're out of credits" panel for pay-as-you-go workspaces.
 * Rendered above the billing grid when `useEntitlements().outOfCredits` is true.
 * Every quick-pick and the primary button open the same BuyCreditsModal — the
 * modal is where the actual amount is chosen.
 */
export default function OutOfCreditsCard({ onBuyCredits, onUpgrade }) {
  return (
    <div className="rounded-2xl border border-red-100 bg-red-50 p-5">
      <div className="flex items-center gap-2 text-red-800 font-semibold mb-1">
        <AlertCircle className="h-4 w-4 flex-shrink-0" /> You're out of credits
      </div>
      <p className="text-sm text-red-800/80 mb-4">
        New test runs and evaluations are paused. Your agents, scenarios, and data are untouched.
      </p>
      <div className="flex flex-wrap gap-2 mb-3">
        {QUICK_PICKS.map((p) => (
          <button
            key={p.dollars}
            onClick={onBuyCredits}
            className="rounded-lg border border-red-200 bg-card px-3 py-2 text-sm font-medium text-red-800 hover:bg-red-100 transition-colors"
          >
            ${p.dollars} · {p.credits.toLocaleString()} credits
          </button>
        ))}
        <button
          onClick={onBuyCredits}
          className="rounded-lg bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-700 transition-colors"
        >
          Add credits
        </button>
      </div>
      {onUpgrade && (
        <button
          onClick={onUpgrade}
          className="text-sm text-red-800 underline underline-offset-2 hover:text-red-900"
        >
          or upgrade to Growth for 12,000 credits/month
        </button>
      )}
    </div>
  );
}
